import './css/style.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import store from './store/store';
import i18n from './utils/i18n';

import Vue3TouchEvents from 'vue3-touch-events'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'

library.add(fas)

createApp(App)
    .component('font-awesome-icon', FontAwesomeIcon)
    .use(router)
    .use(i18n)
    .use(store)
    .use(Vue3TouchEvents)
    .mount('#app')